import { Component, OnInit } from '@angular/core';
import { PracticeService } from '../../services/practice.service';
import {MatDialog} from '@angular/material/dialog';
import { CreatePracticeComponent } from '../../components/modals/create-practice/create-practice.component';
import { Practice } from '../../models/practice';
import { AddMemberToPracticeComponent } from '../../components/modals/add-member-to-practice/add-member-to-practice.component';
import { AddMentorToPracticeComponent } from '../../components/modals/add-mentor-to-practice/add-mentor-to-practice.component';
import { AddMentorToMemberComponent } from '../../components/modals/add-mentor-to-member/add-mentor-to-member.component';
import { PracticeInvitation } from 'src/app/models/practiceInvitation';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { Course } from 'src/app/models/course';
import { ReportingService } from 'src/app/services/reporting.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import * as moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-practice',
  templateUrl: './practice.component.html',
  styleUrls: ['./practice.component.scss']
})
export class PracticeComponent implements OnInit {
  public practice: Practice = new Practice();
  public loadingPractice: boolean = true;
  public removeError:string = null;
  public removeSuccess:boolean = false;
  public invitations:any;
  public mentorInvitations:any;
  public loadingInvitations: boolean = true;
  public loadingMentorInvitations: boolean = true;
  public parentPractice:any;
  public loadingParent: boolean = true;
  public loadingSubscriptions: boolean = true;
  public hasPracticeSubscription:boolean = false;
  public practiceContent:Course[];
  public loadedPracticeContent:boolean=false;
  public loadingMentor:boolean=true;
  public myMentor:any;
  public params={
    fromDate : new Date((new Date()).getFullYear(), 0, 1),
    toDate : new Date(),
    role : 'all',
    status : 'all'
  };
  public thisUser:string;
  public totalSeats:number=20; // based on allocation from base subscription
  public takenSeats:number=0;
  public bacsApplication:any;
  public loadingBacs:boolean=true;
  public showWorking:boolean=false;

  constructor(
    private practiceService: PracticeService,
    public dialog: MatDialog,
    private subscriptionService: SubscriptionService,
    private _reporting: ReportingService,
    private _router: Router,
    private _account: AccountService,
    private _practice: PracticeService,
    private _acc: AccountService,
    private authService: AuthenticationService
  ) {

  }

  ngOnInit() {
    this.getMyPractice();
    this.getInvitations();
    this.getMentorInvitations();
    this.getParentPractice();
    this.getMySubscription();
    this.getPracticeContent();
    this.getMyMentor();
    this.getThisUser();
    this.getBacsApplication();
  }

  getBacsApplication(){
    this._acc.getBacsApplication().subscribe(
      res=>{
        this.bacsApplication=res;
        this.loadingBacs=false;
      }
    );
  }

  getThisUser(){
    let acc = this._account.getLocalAccount();
    this.thisUser=acc.first_name+' '+acc.last_name;
  }

  deactivate(memberId:number){
    this._practice.deactivateMember(memberId).subscribe(
      res=>{
        this.getMyPractice();
      }
    );
  }

  activate(memberId:number){
    this._practice.activateMember(memberId).subscribe(
      res=>{
        this.getMyPractice();
      }
    );
  }

  getMyMentor(){
    this._account.getMyMentor().subscribe(
      res=>{
        if(res.id) this.myMentor=res;
        this.loadingMentor=false;
      }
    );
  }

  getMySubscription(){
    // console.log(new Date().getTime());
    this.subscriptionService.getUserSubscriptions().subscribe(res=>{
      res.forEach(sub=>{
        let then=moment(sub.sub_until);
        let now=moment(new Date());
        let compare=false;
        if (then > now) {
          compare=true;
        }
        if((sub.plan.stripe_reference=='monthly_practice' || sub.plan.stripe_reference=='annual_practice') && (sub.status == 'active' || compare)){
            this.hasPracticeSubscription = true;
        }
        if((sub.plan.stripe_reference=='monthly_seats' || sub.plan.stripe_reference=='annual_seats') && (sub.status == 'active' || compare)){
          this.totalSeats+=sub.quantity;
      }
      })
    })
  }

  getMentorInvitations(){
    this.loadingInvitations = true;
    this.practiceService.getMyMentorInvitations().subscribe(res=>{
      this.mentorInvitations = res;
      this.loadingMentorInvitations = false;
    })
  }

  public acceptMentorInvitation(inviteId:number){
    this.practiceService.acceptMentorInvitation(inviteId).subscribe(
      res=>{
        this.getMentorInvitations();
        this._router.navigate(['/students']);
      }
    );
  }

  public declineMentorInvitation(inviteId:number){
    this.practiceService.declineMentorInvitation(inviteId).subscribe(
      res=>{
        this.getMentorInvitations();
      }
    );
  }

  getInvitations(){
    this.loadingInvitations = true;
    this.practiceService.getMyInvitations().subscribe(res=>{
      this.invitations = res;
      this.loadingInvitations = false;
    })
  }

  leavePractice(){
    if(!confirm('Confirm that you wish to leave this Practice...')) return;
    this.practiceService.leavePractice().subscribe(res=>{
      this.getInvitations();
      this.getParentPractice();
    }, err=>{
    })
  }

  acceptInvitation(practiceInvitation: PracticeInvitation){
    this.practiceService.acceptInvitation(practiceInvitation).subscribe(res=>{
      this.getInvitations();
      this.getParentPractice();
      this.authService.logout();
    })
  }

  declineInvitation(practiceInvitation: PracticeInvitation){
    this.practiceService.declineInvitation(practiceInvitation).subscribe(res=>{
      this.getInvitations();
      this.getParentPractice();
    })
  }

  getParentPractice(){
    this.loadingParent = true;
    this.practiceService.getParentPractice().subscribe(res=>{
      this.parentPractice = res;
      this.loadingParent = false;
    })
  }

  createPractice(){
    const dialogRef = this.dialog.open(CreatePracticeComponent, {
      width: '450px',
      data:{practice: this.practice}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getMyPractice();
      }
    });
  }

  addMember(){
    if(this.totalSeats<=this.takenSeats) {
      return alert('You have allocated all of your available seats. Either purchase additional seats or deactivate existing members to add new members to your Practice.');
    }
    this.resetMessages();
    const dialogRef = this.dialog.open(AddMemberToPracticeComponent, {
      width: '450px',
      data:{practice: this.practice}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getMyPractice();
      }
    });
  }

  addMentor(){
    this.resetMessages();
    const dialogRef = this.dialog.open(AddMentorToPracticeComponent, {
      width: '450px',
      data:{practice: this.practice}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getMyPractice();
      }
    });
  }

  getMyPractice(){
    this.practiceService.getMyPractice().subscribe(practice=>{
      this.practice = practice;
      this.countUpSeats();
      if(this.practice.is_bacs_enabled) this.totalSeats=this.totalSeats+this.practice.bacsSeats;
      this.loadingPractice = false;
    },err=>{
      this.loadingPractice = false;
    })
  }

  public countUpSeats(){
    this.takenSeats=0;
    if(!this.practice.members) return;
    this.practice.members.forEach(member=>{
      if(member.practice_status==1) this.takenSeats++;
    });
  }

  getPracticeContent(){
    this.practiceService.getPracticeContent().subscribe(
      res=>{
        this.practiceContent=res;
        this.loadedPracticeContent=true;
      }
    );
  }

  remove(member_id){
    if(!confirm('Remove this Member?')) return false;
    this.resetMessages();
    this.practiceService.removeMember(member_id).subscribe(res=>{
      this.removeSuccess=true;
      this.getMyPractice();
    },err=>{
      this.removeError = err.error.message;
    })
  }

  cancelInvitation(member_id){
    if(!confirm('Cancel this invitation?')) return false;
    this.resetMessages();
    this.practiceService.cancelInvitation(member_id).subscribe(res=>{
      this.removeSuccess=true;
      this.getMyPractice();
    })
  }

  removeMentor(mentor_id){
    if(!confirm('Remove this Mentor?')) return false;
    this.resetMessages();
    this.practiceService.removeMentor(mentor_id, this.practice.id).subscribe(res=>{
      this.getMyPractice();
    },err=>{
      this.removeError = err.error.message;
    })
  }

  removeMemberMentor(memberId:number, mentorId:number){
    if(confirm('Remove mentor from this user?')) {
      this._practice.removeMemberMentor(memberId, mentorId).subscribe(
        res=>{
          this.getMyPractice();
        }
      );
    }
  }

  assignMemberMentor(memberId:number){
    if(!this.practice.mentors) {
      alert('No mentors are assigned to this Practice.');
      return;
    }
    const dialogRef = this.dialog.open(AddMentorToMemberComponent, {
      width: '450px',
      data:{mentors: this.practice.mentors}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._practice.assignMemberMentor(memberId, result).subscribe(
          res=>{
            this.getMyPractice();
          }
        );
      }
    });
  }

  cancelMentorInvitation(mentor_id){
    if(!confirm('Cancel this invitation?')) return false;
    this.resetMessages();
    this.practiceService.cancelMentorInvitation(mentor_id).subscribe(res=>{
      //this.removeSuccess=true;
      this.getMyPractice();
    })
  }

  private resetMessages(){
    this.removeSuccess=false;
    this.removeError =null;

  }

  public addPracticeContent(){
    if(!confirm('Confirm that you want to add a new Practice Video.')) return;
    this.practiceService.createPracticeContent().subscribe(
      res=>{
        this.practiceContent=res;
        this.getPracticeContent();
      }
    );
  }

  public downloadPracticeReport(){
    this.showWorking=true;
    this._reporting.downloadReport(this.params, this.practice.id).subscribe(
      data=>{
        this.showWorking=false;
        let url = environment.apiEndpoint+data.download_path;
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download ='practice-report.csv';
        a.click();
        a.remove();
        this.deleteReport();
      }
    );
  }

  public deleteReport(){
    this._reporting.deleteCSV(this.practice.id).subscribe(res=>{
      // console.log(res);
    });
  }

  formatStartDate(event){
    this.params.fromDate=event.value.toISOString();
  }

  formatCloseDate(event){
    this.params.toDate=event.value.toISOString();
  }
}
